/*jslint node: true, browser: true*/

"use strict";

var dateBehaviour = require("pli/forms-knockoutcontrols-date").behaviours.date;
var ko = require("pli/knockout");
var pliObservable = require("pli/forms-knockoutcontrols");

var dataCache = require("../datacache");
var entityRegistry = require("../entity-registry");
var formattedBehaviour = require("../ko-behaviours-formatted");
var selectionForm = require("../common-selectionform");
var viewModelInit = require("../document/viewModelInitExtensions");

//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Unit class
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
function Unit(factories) {
    /// <summary>
    /// Define viewmodel.
    /// </summary>
    if (window.console && window.console.group) { window.console.log("Unit.ctor", factories); }

    this.effective = pliObservable(null, null, dateBehaviour, formattedBehaviour);
    this.guid = ko.observable(null);
    this.id = this.tractNumber = pliObservable(null, null, "required");
    this.operator = pliObservable(null, entityRegistry.contact.getPicklistBehaviourData(), "picklist");
    this.participation = pliObservable(null, "N", "numeric");
    this.unitAgreement = pliObservable(null, dataCache.getObservable("contract"), "picklist");
    this.unitName = ko.observable("");
    this.unitNumber = ko.observable("");
    this.zone = pliObservable(null, entityRegistry.zone.getPicklistBehaviourData(), "picklist");

    // non-serialized properties
    this.extras = function UnitExtras() { return; };
    this.extras.errorsCount = ko.computed(factories.computeErrorsCount, this);
}


//-------------------------------------------
Unit.prototype.loadViewModel = function loadUnit(record) {
    /// <summary>
    /// Populate viewmodel with data.
    /// </summary>
    if (window.console && window.console.group) { window.console.log("Unit.loadViewModel", record); }

    if (!record) { record = {}; }
    this.effective(Date.fromJSONDate(record.effective));
    this.guid(record.guid || null);
    this.id.load(record.id);
    this.operator.load(record.operator);
    this.participation.load(record.participation);
    this.unitAgreement.load(record.unitAgreement);
    this.unitName(record.unitName || "");
    this.unitNumber(record.unitNumber || "");
    this.zone.load(record.zone);
};


//-------------------------------------------
Unit.prototype.initGridArray = function initUnitGridArray(gridArray) {
    /// <summary>
    /// Add extra methods to the specified
    /// terms grid array (that has just
    /// been created).
    /// </summary>
    gridArray.deleteAndCloseCurrent = gridArray.factory.factories.secureAction(gridArray.deleteAndCloseCurrent, gridArray);
    gridArray.openNew = gridArray.factory.factories.secureAction(gridArray.openNew, gridArray);
    gridArray.copyItems = gridArray.factory.factories.secureAction(Unit.prototype._copyItems, gridArray);
};


//---------------------------------------
Unit.prototype._copyItems = function copytUnitInfo() {
    /// <summary>
    /// Show selection form that allows users
    /// to find and copy unit info to this array.
    /// </summary>
    /// <remarks>
    /// Expects "this" to be a grid observable
    /// array that creates and stores unit infos.
    /// </remarks>
    selectionForm.open({
        searchApi: "Geo-Document-SearchUnits",
        multiSelect: true,
        text: {
            acceptButton: "Copy",
            iconClass: "sprite-copy-16",
            examples: [
                "<strong>File Numbers</strong>:<br>C-12 will find C-123, C-1234, etc.<br>M001 will find M001, M0019, etc.",
                "<strong>Areas</strong>:<br>river will find GHOST RIVER, TWO RIVERS, etc.",
                "<strong>Lands</strong>:<br>68 17 4 will find Twp 68-Rge 17-W4M<br>94 h 13 c will find 94-H-11-C<br>Note: Sections are not searched",
                "<strong>Combinations</strong>:<br>C, lloyd will find contracts (starting with C) in the Lloydminster area"
            ],
            title: "Copy Unit Info"
        },
        onAcceptedContext: this,
        onAccepted: function (newUnitRows) {
            // push to array
            selectionForm.utils.pushRowItems({
                targetArray: this,
                records: newUnitRows,
                rowMap: { id: 3, participation: 4, unitNumber: 5, unitName: 6, effective: 7, operator: 8, zone: 9, unitAgreement: 10 }
            });
        }
    });
};


//-------------------------------------------
Unit.prototype.itemComparer = null; // disable client-side sorting


//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Exports
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

module.exports = viewModelInit.standardFactoryCreatorFor(
    Unit,
    "units"
);



//////////////////
// WEBPACK FOOTER
// ./app/lease-unit/unitViewModel.js
// module id = 652
// module chunks = 49